import { CmDetailsDataStructure } from 'components/DetailsPageBoilerplate/types';
import { ActionType } from 'screens/Panel/screens/Firm/store/show/actions';
import { Tab } from 'screens/Panel/screens/Firm/components/DueDiligence/DueDiligence';

interface State {
  firm?: CmDetailsDataStructure;
  dueDiligenceTab: Tab;
  isLoading: boolean;
}

const initialState: State = {
  firm: undefined,
  dueDiligenceTab: Tab.SETTINGS,
  isLoading: false,
};

function reducer(state = initialState, action: any): State {
  switch (action.type) {
    case ActionType.SET_FIRM:
      return { ...state, firm: action.payload };

    case ActionType.SET_IS_LOADING:
      return { ...state, isLoading: action.payload };

    case ActionType.SET_DD_TAB:
      return { ...state, dueDiligenceTab: action.payload };

    default:
      return state;
  }
}

export default reducer;
